import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, HostListener, OnInit, Renderer2 } from '@angular/core';
import { MessageService } from 'primeng/api';
import { AllUsers, UserData } from '../../Models/Authentication/UserModel';
import { NotificationMessages } from '../../Models/Notifications/NotifiyMessages';
import { AuthService } from '../../Services/auth.service';
import { BaseApiService } from '../../Services/base-api.service';
import { Router } from '@angular/router';
import { Capacitor } from '@capacitor/core';
import { NavigationService } from '../../Services/navigation.service';
import { TranslateService } from '@ngx-translate/core';
import { Device } from '@capacitor/device';
import { Preferences } from '@capacitor/preferences';
import { takeUntil, finalize } from 'rxjs';
import { BaseComponent } from '../../Base/base/base.component';

@Component({
  selector: 'app-only-admin-navigation',
  templateUrl: './only-admin-navigation.component.html',
  styleUrls: ['./only-admin-navigation.component.css'],standalone:false
})
export class OnlyAdminNavigationComponent extends BaseComponent  implements OnInit{
  changelog: string = 'v3.1.0';
  isDarkTheme: boolean = false;
  shouldReloadPage = false;
  selectedLanguage: string = 'en';
  sidebarVisible: boolean = false;
  Users:AllUsers[]=[];
  userId:string;
  user!:UserData
  userRole!:string
  users: AllUsers[] = []; // Replace with your actual user data
  selectedUser: any;
  loading:boolean=false;
  img:string='../../../assets/images/fr.PNG';
  latestTimestamp!: string;
  notifications:NotificationMessages[]=[]
  deals:NotificationMessages[]=[]
  isSticky: boolean = false;
  username:string="https://touchconnectapp.web.app/"
  isMobile: boolean = false;
  constructor
  (
      private api:BaseApiService,
      private renderer: Renderer2,
      private http:HttpClient,
      private auth:AuthService,
      private messageService:MessageService,
      private Router:Router,
      private el: ElementRef,
      private navigationService: NavigationService,
      private translate :TranslateService
  )
  {
    
    super();
    this.userId=this.auth.getUID();
    this.userRole=this.auth.getRoles().toString();
     const savedLanguage = localStorage.getItem('selectedLanguage');
     if (savedLanguage) {
       this.selectedLanguage = savedLanguage;
  }


     this.setDirection(this.selectedLanguage);
   }

  async switchLanguage(event: Event): Promise<void> {
      const selectedLanguage = (event.target as HTMLSelectElement).value;
      this.translate.use(selectedLanguage);
      const info = await Device.getInfo();
      if (info.platform === 'ios') {
        // For iOS, use Capacitor Preferences to store the selected language
        Preferences.set({
          key: 'language',
          value: selectedLanguage,
        });
      } else {
        // For Web, use localStorage to store the selected language
        localStorage.setItem('language', selectedLanguage);
      }
    }
    
   @HostListener('window:scroll', [])
   onWindowScroll() {
    // Check scroll position and add/remove sticky class
    const scrollPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;

    if (scrollPosition >= 1) { // Adjust the threshold as needed
      this.renderer.addClass(this.el.nativeElement, 'sticky');
      this.isSticky = true;
    } else {
      this.renderer.removeClass(this.el.nativeElement, 'sticky');
      this.isSticky = false;
    }
  }

  showSidebar: boolean = true;
  showSide:boolean     =false;

  goBack(): void {
    this.navigationService.goBack();
  }

  toggleColumnLayout() {

    this.showSidebar = !this.showSidebar;
    if (this.showSidebar) {

      this.renderer.addClass(document.querySelector('#db-wrapper'), 'toggled');
    } else {

      this.renderer.removeClass(document.querySelector('#db-wrapper'), 'toggled');


    }




  }

  isRouteActive(routes: string[]): boolean {
    const currentUrl = this.Router.url;
    if(routes.some(route => currentUrl.startsWith(route))){
      return true;
    }
    else{
      return routes.some(route => this.Router.isActive(route, true));
    }
  }

  logut(){
    this.auth.logout();
    this.Router.navigate(['/login'])
  }

GetNotifications(userId:string){
    this.loading=true;
    this.api.read(`Profile_Service/Notifications?userid=${userId}&type=Alert`)
    .pipe(
      takeUntil(this.destroy$),
      finalize(() => this.loading = false)
    ).subscribe
    (
      {
        next:  (response)=>{
          this.notifications   = response;
          this.latestTimestamp = this.findLatestTimestamp();
          this.loading         = false;
        },
        error: (error) => {
          this.loading = false;
          this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
        }
      }
    )
  }


  private findLatestTimestamp(): string {
    let latestTimestamp = '';

    for (const notification of this.notifications) {
      if (!latestTimestamp || new Date(notification.timestamp) > new Date(latestTimestamp)) {
        latestTimestamp = notification.timestamp;
      }
    }

    return latestTimestamp;
  }
  toggleFullScreen() {
    const doc = window.document as any;
    const docEl = doc.documentElement as any;  // Cast docEl to any

    const requestFullScreen = docEl.requestFullscreen || docEl.webkitRequestFullscreen || docEl.msRequestFullscreen;
    const exitFullScreen = doc.exitFullscreen || doc.mozCancelFullScreen || doc.webkitExitFullscreen || doc.msExitFullscreen;

    if (!doc.fullscreenElement ) {
      // Enter full-screen mode
      if (requestFullScreen) {
        requestFullScreen.call(docEl);
      }
    } else {
      // Exit full-screen mode
      if (exitFullScreen) {
        exitFullScreen.call(doc);
      }
    }
  }

  getClassForRoute(route: string): string {
    const isActive = this.Router.isActive(route, true);

    if (isActive) {
      return 'nav-link u-sidebar-nav-menu__link active smooth-shadow-lg mb-1';
    } else {
      return 'nav-link u-sidebar-nav-menu__link mb-1';
    }
  }



  searchUsers(event: any) {

    const query = event.query.toLowerCase();
    this.users = this.Users.filter((user) =>
      user.name.toLowerCase().includes(query) ||
      user.email.toLowerCase().includes(query)
    );

  }

  getdata(uid:any){
    this.loading=true;
    this.api.read(`Auth/getByIdDT?uid=${uid}`)
    .pipe(
      takeUntil(this.destroy$),
      finalize(() => this.loading = false)
    )
    .subscribe
    (
      {
        next:(response)=>{
          this.user = response;
          this.username=this.username+this.user.userName
          this.loading=false;
        },
        error:(error)=>{
          this.loading=false;
          this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
        }
      }
    )
  }

  onSelectUser(event: any) {
    try {

      this.Router.navigate(['/',event.name]); // Example navigation
    } catch (error) {

    }
  }

  getUser(){
    this.loading=true;
    this.api.read("Auth/GetusersAll")
    .pipe(
      takeUntil(this.destroy$),
      finalize(() => this.loading = false)
    )
    .subscribe
    (
      {
        next:(response)=>{
          this.loading=false;
          this.Users = response;
  
        },
        error:
        (
          error
        )=>{
         this.loading=false;
         this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
        }
      }
    )
  }

  logOut(){
    this.auth.logout();
    this.Router.navigate(['/login']);
  }

  ngOnInit() {
     this.isMobile = Capacitor.getPlatform() === 'android' || Capacitor.getPlatform() === 'ios';
        
        if (this.isMobile) {
          this.renderer.addClass(document.body, 'mobile-platform');
        }
    this.userRole=this.auth.getRoles().toString();
    if(this.userRole=="Administrator")
    {
      this.getUser()
    }
    if(this.userId!=''){
      this.GetNotifications(this.userId);
      this.getdata(this.userId)
    }
    const theme = localStorage.getItem('theme');
    if (theme === 'dark') {
      this.isDarkTheme = true;
      document.documentElement.setAttribute('data-theme', 'dark');
    } else {
      this.isDarkTheme = false;
      document.documentElement.setAttribute('data-theme', 'light');
    }

  }

  toggleTheme() {
    this.isDarkTheme = !this.isDarkTheme;
    if (this.isDarkTheme) {
      document.documentElement.setAttribute('data-theme', 'dark');
      localStorage.setItem('theme', 'dark');
    } else {
      document.documentElement.setAttribute('data-theme', 'light');
      localStorage.setItem('theme', 'light');
    }

  }



  changeLanguage(language: string) {
    localStorage.setItem('selectedLanguage', language);
    this.shouldReloadPage = true;
    this.setDirection(language);
  }

  private setDirection(language: string) {
    const direction = language === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.setAttribute('dir', direction);

  }
}
